import React from 'react';

const ProcessingIconStatus = () => {
  return (
    <div className="vbz-icon-beneficiaries refreshing">
      <div className="vbz-icon-beneficiaries-processing-status" />
    </div>
  );
};

export default ProcessingIconStatus;
